import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { SessionService } from '../services/session/session.service';

@Injectable({
    providedIn: 'root'
})
export class SessionGuard implements CanActivate {
    private readonly sessionService = inject(SessionService);
    private readonly router = inject(Router);

    public canActivate(): boolean {
        if (this.sessionService.hasSession()) {
            return true;
        }
        this.router.navigateByUrl('/session-pending');
        return false;
    }
}
